import {FETCH_STORES} from 'constants/ActionTypes';

const INIT_STATE = [];

export default (state = INIT_STATE , action) => {
    switch(action.type) {
        case FETCH_STORES : {
            if (action.payload == undefined) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } ;
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/appRedux/reducers/placeStores.js